import * as Sentry from "@sentry/vue";
import { AppConfig } from "./AppConfig";

const isDev = import.meta.env.DEV;

export function configureSentry(app, router) {
  if (!isDev) {
    Sentry.init({
      app,
      dsn: "https://a7d2fcd227d74abe2e982eedee8aaa88@o4508262192709632.ingest.us.sentry.io/4508262194348032",
      integrations: [Sentry.browserTracingIntegration({ router })],
      environment: AppConfig.deploymentEnv,
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^\/api\//],
      // Session Replay
      // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      trackComponents: true,
      normalizeDepth: 10,
    });

    Sentry.setContext("oiviEnvironment", {
      region: AppConfig.region,
      isProduction: AppConfig.isProduction,
      deploymentEnv: AppConfig.deploymentEnv,
    });
  }
}
